import { API_JWT_TOKEN_NAME, CALL_API } from '../middleware/api'
import { API_ENDPOINT_APP_CONTEXT, API_ENDPOINT_TX_APP_CONTEXT } from '../config'

export const APP_CONTEXT_REQUEST = 'APP_CONTEXT_REQUEST'
export const APP_CONTEXT_SUCCESS = 'APP_CONTEXT_SUCCESS'
export const APP_CONTEXT_FAILURE = 'APP_CONTEXT_FAILURE'

export const APP_CONTEXT_REQUEST_TX = 'APP_CONTEXT_REQUEST_TX'
export const APP_CONTEXT_SUCCESS_TX = 'APP_CONTEXT_SUCCESS_TX'
export const APP_CONTEXT_FAILURE_TX = 'APP_CONTEXT_FAILURE_TX'

export function fetchAppContext() {
  return {
    [CALL_API]: {
      endpoint: API_ENDPOINT_APP_CONTEXT,
      types: [APP_CONTEXT_REQUEST, APP_CONTEXT_SUCCESS, APP_CONTEXT_FAILURE],
      method: 'GET',
      tokenType: API_JWT_TOKEN_NAME,
    },
  }
}

export function fetchAppContextForTx(txId) {
  return {
    [CALL_API]: {
      endpoint: `${API_ENDPOINT_TX_APP_CONTEXT}/?transaction_id=${txId}`,
      types: [APP_CONTEXT_REQUEST_TX, APP_CONTEXT_SUCCESS_TX, APP_CONTEXT_FAILURE_TX],
      method: 'GET',
      tokenType: API_JWT_TOKEN_NAME,
    },
  }
}
